import { Components, Theme } from '@mui/material';
import { PaperProps } from '@/components/Paper';

const components: Components<Omit<Theme, 'components'>>['MuiPaper'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...(theme.palette.mode === 'dark'
        ? {
            backgroundColor: theme.palette.base.A40,
            backgroundImage: 'none',
            boxShadow: 'none'
          }
        : {})
    }),
    outlined: ({ theme }) => ({
      border: `1px solid ${theme.palette.base.A20}` // need color for dark
    }),
    rounded: {
      borderRadius: 16
    }
  },
  variants: [
    {
      props: { hasBg: true } as PaperProps,
      style: ({ theme }) => {
        if (theme.palette.mode === 'light') {
          return {
            backgroundColor: theme.palette.secondary.A60
          };
        } else return {};
      }
    }
  ]
};

export default { components };
